import { jsx as _jsx } from "react/jsx-runtime";
import { useDirection } from "@jti/fe-common";
export const brandIcons = {
    width: "1em",
    height: "1em",
    viewBox: "0 0 100 100",
    fill: "currentColor",
};
function iconFactory(iconName, LtrSvg, RtlSvg) {
    if (RtlSvg === undefined) {
        const Icon = (props) => {
            return _jsx(LtrSvg, { "data-dir": "ltr", "data-name": iconName, ...brandIcons, ...props });
        };
        Object.defineProperty(Icon, "name", { value: iconName, writable: false });
        return Icon;
    }
    const Icon = (props) => {
        const { direction, ...restProps } = props;
        const dir = useDirection(direction);
        const Component = dir === "rtl" ? RtlSvg : LtrSvg;
        return _jsx(Component, { "data-dir": dir, "data-name": iconName, ...brandIcons, ...restProps });
    };
    Object.defineProperty(Icon, "name", { value: iconName, writable: false });
    return Icon;
}
export { iconFactory };
//# sourceMappingURL=iconFactory.js.map